import styled from '@emotion/styled';
import Divider from '@portalterreno/react-ui-core/Divider';

const StyledDivider = styled(Divider)({
  marginTop: 15,
  marginBottom: 15
});

export default StyledDivider;
